export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_08.d4f8ae46.jpg";